<script>
    //imports
    import {clickOutside} from '../util.js';
    import { createEventDispatcher } from 'svelte';

    let menuActive = false;
    export let selectedOption = 2;
    export let imageData;

    let options = new Array();

    if(imageData.length > 0){
        imageData.forEach(function(image, index) {
            options[index] = image.title;
        });
    }

	  const dispatch = createEventDispatcher();


    // functions
    let toggleMenu = () => {
        menuActive = !menuActive;
    }

    let displayOption = (index) => {
        selectedOption = index;

        dispatch('select', {
          index: index
        });

        toggleMenu();
    }
</script>

<div class="relative inline-block text-left z-10" use:clickOutside on:click_outside={menuActive ? toggleMenu : ''}>
    <div>
      <span class="rounded-md shadow-sm">
        <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150" style="color: white; background: #00467F;" id="options-menu" aria-haspopup="true" aria-expanded="true" on:click={() => toggleMenu()}>
          {options[selectedOption]}
          <!-- Heroicon name: chevron-down -->
          <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </button>
      </span>
    </div>
  
    <!--
      Dropdown panel, show/hide based on dropdown state.
  
      Entering: "transition ease-out duration-100"
        From: "transform opacity-0 scale-95"
        To: "transform opacity-100 scale-100"
      Leaving: "transition ease-in duration-75"
        From: "transform opacity-100 scale-100"
        To: "transform opacity-0 scale-95"
    -->
    <div class:hidden={!menuActive} class="origin-top-right absolute left-0 mt-2 w-56 rounded-md shadow-lg">
      <div class="rounded-md bg-white shadow-xs">
        <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          {#each options as option, i}
            <button on:click={() => displayOption(i)} class="block text-left w-full px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">{options[i]}</button>
          {/each}
        </div>
      </div>
    </div>
  </div>